import { useEffect, useState } from "react";

const useIsTouchscreen = () => {
  const [isTouchscreen, setIsTouchscreen] = useState(false);

  useEffect(() => {
    if (window.navigator.maxTouchPoints > 0) {
      setIsTouchscreen(true);
    }
  }, []);

  return isTouchscreen;
};

export default useIsTouchscreen;
